import Vue from "vue";
import App from "./App.vue";
import Store from "./store";
import Request from "./plugins/request";
import VueRouter from "vue-router";
import Router from "./router/router";

import {
  Container,
  Col,
  Aside,
  Main,
  Header,
  Footer,
  Button,
  Input,
  Row,
  Form,
  FormItem,
  Table,
  TableColumn,
  Switch,
  Menu,
  MenuItem,
  Message,
  Loading,
  Pagination,
  Select,
  Option,
  Divider,
  Empty,
  DatePicker,
  TimePicker,
  TimeSelect,
} from "element-ui";

Vue.config.productionTip = false;

Vue.use(Request);
Vue.use(VueRouter);

Vue.component(Container.name, Container);
Vue.component(Aside.name, Aside);
Vue.component(Main.name, Main);
Vue.component(Button.name, Button);
Vue.component(Input.name, Input);
Vue.component(Row.name, Row);
Vue.component(Form.name, Form);
Vue.component(FormItem.name, FormItem);
Vue.component(Table.name, Table);
Vue.component(TableColumn.name, TableColumn);
Vue.component(Header.name, Header);
Vue.component(Footer.name, Footer);
Vue.component(Col.name, Col);
Vue.component(Switch.name, Switch);
Vue.component(Menu.name, Menu);
Vue.component(MenuItem.name, MenuItem);
Vue.component(Pagination.name, Pagination);
Vue.component(Select.name, Select);
Vue.component(Option.name, Option);
Vue.component(Divider.name, Divider);
Vue.component(Empty.name, Empty);
Vue.component(DatePicker.name, DatePicker);
Vue.component(TimePicker.name, TimePicker);
Vue.component(TimeSelect.name, TimeSelect);

Vue.prototype.$message = Message;
Vue.use(Loading.directive);
Vue.prototype.$loading = Loading.service;

new Vue({
  render: (h) => h(App),
  store: Store,
  router: Router,
}).$mount("#app");
